<template>
  <div class="app-layout">
    <!-- Header -->
    <header class="header">
      <h1>Coal HPB Calculator</h1>
    </header>
    <!-- Announcement -->
    <div class="marquee-container">
      <div class="marquee">
        ⚡️ Welcome to Free HPB Calculator – Instant & Accurate Coal Pricing! | New update: 2nd Period of April HBA values added | Contact versasoft.id@gmail.com for custom software solutions.
      </div>
    </div>
    <div class="ad-top ad-slot ad-slot-wide">
      <span class="ad-label">Partner placement</span>
      <a :href="mailtoLink" aria-label="Contact us about advertising">
        <img src="/ads/top-ad.png" alt="Available advertising placement" />
        <span class="ad-action">Promote your business <span aria-hidden="true">↗</span></span>
      </a>
    </div>
    <!-- Main Content -->
    <div class="container">
      <div class="main-content">
        <!-- Left Ad -->
        <div class="ad-side ad-slot">
          <span class="ad-label">Partner placement</span>
          <a :href="mailtoLink" aria-label="Contact us about advertising">
            <img src="/ads/left-ad.png" alt="Available advertising placement" />
          </a>
        </div>

        <!-- Center Content -->
        <div class="calculator-wrapper">
          <CalculateHPB />
        </div>

        <!-- Right Ad -->
        <div class="ad-side ad-slot">
          <span class="ad-label">Partner placement</span>
          <a :href="mailtoLink" aria-label="Contact us about advertising">
            <img src="/ads/right-ad.png" alt="Available advertising placement" />
          </a>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <footer class="footer">
      © 2025 Versasoft.Id. All rights reserved.
      <!-- Short disclaimer with link -->
      <div class="disclaimer">
        ⚠️ <span>Disclaimer: This calculator is provided for general informational purposes only and is intended for preliminary estimates related to coal industry operations.</span><br>
        <a href="/disclaimer.html" target="_blank">Read full disclaimer</a>
      </div>
    </footer>
  </div>
</template>

<script>
import CalculateHPB from './components/CalculateHPB.vue'

export default {
  name: 'App',
  components: {
    CalculateHPB
  }
  /* data() {
    return {
      phoneNumber: "6281808776877", // Replace with your WhatsApp number
    };
  },
  computed: {
    whatsAppLink() {
      const message = encodeURIComponent("Hi Versasoft, I want to put an ads on your web.");
      return `https://wa.me/${this.phoneNumber}?text=${message}`;
    }
  } */
}
</script>
<script setup>
  const subject = encodeURIComponent("Ad Click from Free HPB Calculator");
  const body = encodeURIComponent("Hi, I'm interested in advertising. Please contact me.");
  const mailtoLink = `mailto:versasoft.id@gmail.com?subject=${subject}&body=${body}`;
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: 'Segoe UI', sans-serif;
  background: #eef3f7;
}

.header {
  background-color: #0d4f86;
  color: white;
  padding: 20px;
  text-align: center;
}

.container {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 34px 20px 48px;
  box-sizing: border-box;
  overflow-x: hidden;
}

.main-content {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 28px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.ad-slot {
  position: relative;
  background: #ffffff;
  border: 1px solid #d8e1e8;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(25, 55, 75, 0.08);
  box-sizing: border-box;
}

.ad-slot a {
  display: block;
  overflow: hidden;
  border-radius: 7px;
}

.ad-label {
  display: block;
  padding: 10px 12px 8px;
  color: #6b7d8c;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-align: center;
  text-transform: uppercase;
}

.ad-slot img {
  width: 100%;
  display: block;
  object-fit: cover;
  transition: transform 180ms ease, filter 180ms ease;
}

.ad-slot a:hover img {
  filter: brightness(0.96);
  transform: scale(1.015);
}

.ad-slot-wide {
  width: min(920px, calc(100% - 40px));
  margin: 24px auto 0;
  padding: 0 12px 12px;
}

.ad-slot-wide img {
  max-height: 86px;
}

.ad-action {
  display: block;
  padding: 9px 4px 0;
  color: #0d4f86;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

.calculator-wrapper {
  flex: 1;
  max-width: 620px;
  width: 100%;
}

.ad-side {
  flex: 0 0 132px;
  padding: 0 6px 10px;
}

.ad-side img {
  min-height: 250px;
  object-fit: cover;
}

.footer {
  background: #222;
  color: #ccc;
  text-align: center;
  padding: 15px;
  font-size: 14px;
}

.disclaimer {
  margin-top: 1em;
  font-size: 0.9em;
  color: #ccc;
}

.disclaimer a {
  color: #007BFF;
  text-decoration: none;
  margin-left: 5px;
}

.disclaimer a:hover {
  text-decoration: underline;
}

/* Tooltip */
.tooltip {
  position: relative;
  cursor: help;
  border-bottom: 1px dotted #555;
}

.marquee-container {
  width: 100%;
  overflow: hidden;
  background-color: #2f87cf;
  border-bottom: 1px solid #0d4f86;
  padding: 6px 0;
}

.marquee {
  display: inline-block;
  white-space: nowrap;
  animation: scroll-left 15s linear infinite;
  font-size: 16px;
  color: #ffffff;
  padding-left: 100%;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

@media (max-width: 768px) {
  .ad-slot-wide {
    width: calc(100% - 24px);
    margin-top: 16px;
  }

  .container {
    padding: 24px 12px 36px;
  }

  .main-content {
    flex-direction: column;
    align-items: center;
  }

  .ad-side {
    display: none;
  }

  .calculator-wrapper {
    width: 100%;
    max-width: 100%;
  }
}
</style>
